module.exports = __webpack_public_path__ + "7f14710ca7a24b5ce001e241bda76baf.pdf";